import * as pluralize from 'pluralize';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';
import { BaseApiClient } from '../base-api-client';

export function Archivable<T>() {

    return function (target) {

        const archive = function (id: string): Observable<T> {
            return this.toggleArchive(id, true);
        };

        const unarchive = function (id: string): Observable<T> {
            return this.toggleArchive(id, false);
        };

        const toggleArchive = function (id: string, archived: boolean): Observable<T> {
            if (!(this instanceof BaseApiClient)) {
                throw new Error('Decorated element must by type BaseApiClient');
            }
            let options = this.prepareRequestOptionsForDecorators();

            return this.http
                .patch(`${this.apiBase()}/${id}`,
                    {
                        'data': {
                            'id': id,
                            'type': pluralize.singular(this.classConfig().apiResourceName),
                            'attributes': {
                                'archived': archived
                            }
                        }
                    },
                    options
                )
                .pipe(
                    map((response: HttpResponse<any>) => {
                        return Object.assign({},
                            response.body.data.attributes, { id: response.body.data.id }) as T;
                    })
                );
        };

        target.prototype.archive = archive;
        target.prototype.unarchive = unarchive;
        target.prototype.toggleArchive = toggleArchive;

    };

}
